import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled } from '@zenbusiness/zui/styles';

const DashboardWrapperStyle = {
  paddingTop: 24
};

const DividerStyle = () => ({
  border: 'none',
  borderBottom: '1px solid #C7C7C7',
  margin: '10px 0'
});

const ButtonStyle = ({ theme }) => ({
  height: '56px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    minWidth: '130px',
    width: 'auto',
    whiteSpace: 'nowrap'
  }
});

const SharedAssetStyle = ({ theme }) => ({
  width: '100%',
  transform: 'scale(1.3)',
  [theme.breakpoints.up('md')]: {
    transform: 'scale(1.02)'
  }
});

const BankingImageStyle = () => ({
  width: '100%'
});

export const DashboardWrapper = styled(Box)(DashboardWrapperStyle);
export const DividerStyled = styled('hr')(DividerStyle);
export const ButtonStyled = styled(Button)(ButtonStyle);
export const SharedAssetStyled = styled(SharedAsset)(SharedAssetStyle);
export const BankingImage = styled(SharedAsset)(BankingImageStyle);
